import React from 'react'
import Navbar from '../../../components/navbar';
import LogoutModel from '../../../components/Models/LogoutModel';
import Footer from '../../../components/footer';
import Sidebar from '../../../components/sidebar';
import AddClinentForm from './AddClinentForm';


const AddClient = () => {
  return (
    <div>
      {/* Page Wrapper */}
      <div id="wrapper">
        {/* Sidebar */}
        <Sidebar />
        {/* Content Wrapper */}
        <div id="content-wrapper" className="d-flex flex-column">
          {/* Main Content */}
          <div id="content">
            {/* Topbar */}
            <Navbar navTitle={"Add Client"}/>
            {/* Begin Page Content */}
            <AddClinentForm />
            {/* /.container-fluid */}
          </div>
          {/* Footer */}
          <Footer />
        </div>
      </div>
      {/* Logout Modal*/}
      <LogoutModel />
    </div>
  )
}

export default AddClient;
